import apiUrl from '../../../../../utils/settings';

export const annualTripDetailsUrl = () => {
  return apiUrl + '/benefits-v2/annual-trip-details';
};
